import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class AsoMultiFilter extends Component {
    state = {
        asoTypeLists:[],
        asoTypeValue: null,
        isasoLoading: true
    };
    componentDidMount(){
        this.getasoType();
    }
    restAsoFilter() {
        this.setState({
            asoTypeValue: [],
        })
    }
    getasoType(){
        axios.get(config.get('API_URL')+'/filters/get-aso-details/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((aso, index) => {
                    this.state.asoTypeLists.push({value: aso.employee_id_and_name, label: aso.employee_id_and_name})
                });
            }
            this.setState({
                loading:false,
                isasoLoading: false
            })
        });

    }


    changeasoType(optionSelected){
        let value='';
        let asoArray = [];
        if(optionSelected.length < 1){
            value = null;
            asoArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                asoArray.push(ids.value)
                var index = this.state.asoTypeLists.findIndex(obj => obj.value==ids.value);
                this.state.asoTypeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectaso(optionSelected, asoArray);
        this.setState({
            asoTypeValue:optionSelected,
        });

    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="aso_list"
                isMulti
                value={this.state.asoTypeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeasoType.bind(this)}
                options={this.state.asoTypeLists}
                placeholderButtonLabel="Select [Aso]"
                isLoading={this.state.isasoLoading}
            />
        );
    }
}
export default AsoMultiFilter;